import { ButtonRoundSm, ControlledInputDebounced } from '@apps-common/components/elements'
import { ModalBody, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

import { useMyMonitoringFilterStore } from '@apps-common/stores/useMyMonitoringFilterStore'
import { FilterModalContainer } from './filter/FilterModalContainer'

export const MyMonitoringFilterModal = ({
  onDismiss
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
}) => {
  const state = useMyMonitoringFilterStore()

  return (
    <FilterModalContainer onDismiss={onDismiss}>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='myMonitoring Accounts' title='Filter' subtitleClasses='capitalize' />
          <div className='flex items-center gap-[10px]'>
            <ButtonRoundSm
              type='button'
              className='action-brand'
              callback={() => {
                state.clear()
                onDismiss(null, ModalDismiss.Confirm)
              }}
            >
              <commonIcons.reload />
            </ButtonRoundSm>
            <ButtonRoundSm
              type='button'
              className='action-brand-solid'
              callback={() => {
                onDismiss(null, ModalDismiss.Cancel)
              }}
            >
              <commonIcons.close />
            </ButtonRoundSm>
          </div>
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='relative !pt-[85px] !pb-[30px] sm:!pb-[20px]'>
        <div className='grid gap-[10px]'>
          <ControlledInputDebounced
            type='text'
            placeholder='Start typing to search...'
            label='Search'
            showLabel
            id='myMonitoringSearch'
            containerClassName='grow sm:grow-0 sm:min-w-[260px]'
            hideErrors
            value={state.search}
            onChange={(e: any) => {
              console.log('Search value:', state.search, e?.target?.value || '')
              state.setSearch(e?.target?.value || '')
            }}
          />
        </div>
      </ModalBody>
    </FilterModalContainer>
  )
}
